import React, { Component } from 'react';
import { Card, ListGroup } from 'react-bootstrap';

export class YoungMen extends Component {
    render() {
        return <div>
            <h3>Young Men</h3>
            <br />
            <Card>
                <Card.Body>
                    <Card.Title>
                        Class Sunday @ 1:10pm - 2:00pm
                    </Card.Title>
                    <h4>
                        Meeting every 2nd and 4th Sunday of each month.
                    </h4>             
                </Card.Body>              
            </Card>
            <hr />
            <Card>
                <Card.Body>
                    <Card.Title>
                    Young Men's - Tuesdays @ 7:00pm
                    </Card.Title>
                    <h4>
                        Contact your quorum presidency for details.
                    </h4>             
                </Card.Body>              
            </Card>
        </div>;
    }
}

export default YoungMen;